/* eslint-disable react/prop-types */
/* eslint-disable @typescript-eslint/dot-notation */
import React, { useContext } from 'react';
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import {
  Dialog,
  DialogContent,
  DialogContentText,
  FormControlLabel,
  Radio,
  RadioGroup,
  Typography,
  Snackbar,
  Alert,
} from '@mui/material';
import { useEffect, useState } from 'react';
import ProdutoCarrinhoView from '../../../components/ProdutoCarrinhoView/ProdutoCarrinhoView';
import { useApi } from '../../../hooks/userApi';
import { CarrinhoContext } from '../../../context/Carrinho/CarrinhoContext';
import ProdutoView from '../../../components/ProdutoView/ProdutoView.component';
import { useLocation, useNavigate } from 'react-router-dom';
import { LoadingContext } from '../../../context/Loading/LoadingContext';
import { FiltroWrapper, TDialogActions, TFormControl, TextInputP } from 'styles/CalculoProduto/CalculoProduto.style';
import ButtonPrimary from 'components/Buttons/ButtonPrimary/ButtomPrimary.component';
import { colors } from 'utils/colors';
import ButtonCircle from 'components/Buttons/ButtonCircle/ButtonCircle.component';
import ButtonSecondary from 'components/Buttons/ButtonSecondary/ButtonSecondary.component';
import ButtonTerciary from 'components/Buttons/ButtonTerciary/ButtonTerciary.component';

const api = useApi();

const DadosDoCliente = (props) => {
  const dataProps = [
    { key: 'nome', value: 'Nome do Cliente' },
    { key: 'telefone', value: 'Telefone do Cliente' },
    { key: 'vendedor', value: 'Vendedor' },
  ];
  const [open, setOpen] = useState(false);

  const handclick = () => {
    window.location.href = '/vendedor/listaClientes';
  };

  const handleClickOpen = (v = true) => {
    setOpen(v);
  };

  const handleClose = () => {
    setOpen(false);
  };
  return (
    <Box>
      <Box
        sx={{
          fontWeight: 'bold',
          fontSize: '12px',
          color: colors.verde,
          p: 1,
          m: 0,
        }}
      >
        DADOS DO CLIENTE
      </Box>
      <FiltroWrapper
        sx={{
          p: 1,
          m: 0,
        }}
      >
        {dataProps.map((item, key) => (
          <TextInputP
            id="standard-select-currency-native"
            label={item.value}
            key={key}
            value={props[item.key]}
            variant="standard"
            disabled
          ></TextInputP>
        ))}
        <ButtonPrimary label={'+ NOVO ORÇAMENTO'} typeSubmit={false} onClick={() => handleClickOpen()} />
      </FiltroWrapper>

      <Dialog
        open={open}
        onClose={() => handleClickOpen(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent>
          <DialogContentText
            id="alert-dialog-description"
            textAlign={'center'}
            fontWeight={'600'}
            color={colors.verde05}
          >
            DESEJA SAIR DESSE ORÇAMENTO?
          </DialogContentText>
        </DialogContent>

        <TDialogActions>
          <ButtonSecondary label={'SIM'} typeSubmit={false} onClick={handclick} />
          <ButtonTerciary label={'NÃO'} typeSubmit={false} onClick={handleClose} />
        </TDialogActions>
      </Dialog>
    </Box>
  );
};

const FiltroProduto = (props) => {
  const [categoria, setCategoria] = useState(props.categorias[0]);
  const handleEvent = (e) => {
    props.updateResult(e);
    setCategoria(e);
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        alignItems: 'end',
        p: 1,
        m: 0,
        marginBottom: '20px',
      }}
    >
      <Box
        sx={{
          fontWeight: 'bold',
          fontSize: '12px',
          color: colors.verde05,
          marginRight: '60px',
          p: 1,
          m: 0,
        }}
      >
        FILTRO POR PESQUISA
      </Box>
      <TFormControl>
        <RadioGroup row aria-labelledby="demo-row-radio-buttons-group-label" name="row-radio-buttons-group">
          {props.categorias.map((item, index) => (
            <FormControlLabel
              name="categoria"
              key={index}
              value={item.id}
              checked={categoria.id === item.id}
              control={<Radio />}
              onMouseDown={() => handleEvent(item)}
              label={item.nome}
            />
          ))}
        </RadioGroup>
      </TFormControl>
    </Box>
  );
};

const BtnPlus = ({ add }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        flexWrap: 'wrap',
      }}
    >
      <div>
        <ButtonCircle textToolTip="Adicionar ao Carrinho" label={'+'} typeSubmit={false} onClick={() => add()} />
      </div>
    </Box>
  );
};

const BtnFinalizar = () => {
  const navigate = useNavigate();
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-end',
        flexWrap: 'wrap',
      }}
    >
      <div style={{ width: '100%', justifyContent: 'center', display: 'flex', margin: '30px 20px' }}>
        <ButtonPrimary
          label={'Finalizar orçamento'}
          typeSubmit={false}
          onClick={() => navigate('/vendedor/checkout')}
        />
      </div>
    </Box>
  );
};

const CalculoProdutoPreco = () => {
  const idCliente = window.location.pathname.split('/').pop();
  const vendedor = JSON.parse(sessionStorage.getItem('user'));
  const [indexCategoria, setIndexCategoria] = useState(0);
  const [loadCategorias, setLoadCategorias] = useState(false);
  const [produtosListado, setProdutosListado] = useState([]);
  const [results, setResults] = useState({});
  const [produto, setProduto] = useState({});
  const [open, setOpen] = React.useState(false);
  const [mensagemBar, setMensagemBar] = useState('');

  const location = useLocation();

  const { setLoading, setLoadingMensagem, setLoadingBtn, setLoadingAction, setClearLoading }: any =
    useContext(LoadingContext);

  const { produtoCar, addProdutoCar, removeProdutoCar, addClienteCar }: any = useContext(CarrinhoContext);

  useEffect(() => {
    if (location.state?.produtosAtuais) {
      location.state.produtosAtuais.forEach((prod) => {
        if (!produtoCar.some((p) => p.id === prod.id)) {
          addProdutoCar({
            ...prod,
          });
        }
      });
    }
  }, [location.state?.produtosAtuais]);

  const endpoints = {
    cliente: `/cliente/${idCliente}`,
    categorias: '/categoria',
    partilha: '/icms-partilha',
  };

  const updateResult = (r) => {
    setIndexCategoria(r.id);
    setLoadCategorias(true);
  };

  const carrega = async () => {
    setLoading(true);
    try {
      const responses = [];
      await Promise.all(
        Object.entries(endpoints).map(async ([key, url]) => {
          const res = await api.get(url);
          responses[key] = res;
        }),
      );
      setResults(responses);
      setIndexCategoria(responses['categorias'][0].id);
      addClienteCar(responses['cliente']);
      setClearLoading(true);
      setLoadCategorias(true);
    } catch (e) {
      const msg = 'Houve um erro interno, tente mais tarde. ' + e.message;
      if (e.code === 401) setLoadingAction('/login');
      setLoadingMensagem(msg);
      setLoadingBtn('OK');
    }
  };

  const carregaProdutos = async () => {
    setLoading(true);
    try {
      const responses = await api.get('produto/categoria/' + indexCategoria);
      setLoadCategorias(false);
      if (responses.length <= 0) {
        setProdutosListado([]);
        setLoadingMensagem('Desculpe, não foi possivel listar os produtos dessa categoria. Tente mais tarde!');
        setLoadingBtn('OK');
        return;
      }
      setClearLoading(true);
      setProdutosListado(responses);
    } catch (e) {
      const msg = 'Houve um erro interno, tente mais tarde.. ' + e.message;

      setLoadingMensagem(msg);
      setLoadingBtn('OK');
    }
  };

  useEffect(() => {
    carrega();
  }, []);

  useEffect(() => {
    if (!loadCategorias) {
      return;
    }
    carregaProdutos();
  }, [loadCategorias]);

  const addCarrinho = () => {
    console.log(produto);
    if (!produto?.['produto'].hasOwnProperty('created_at')) {
      setMensagemBar('Selecione um PRODUTO!');
      setOpen(true);
      return;
    }
    if (!produto?.['produto'].hasOwnProperty('extra')) {
      setMensagemBar('Selecione um PRODUTO!');
      setOpen(true);
      return;
    }
    if (produto['quantidade'] <= 0) {
      setMensagemBar('A quantidade de PRODUTO é inválida.');
      setOpen(true);
      return;
    }
    if (produto['valor'] <= 0) {
      setMensagemBar('Valor do produto não pode ser R$ 0,00');
      setOpen(true);
      return;
    }
    addProdutoCar(produto);
  };

  const removerProduto = async (id) => {
    setLoading(true);
    await removeProdutoCar(id);
    setLoading(false);
  };

  const produtoSelecionado = (produtoP) => {
    setProduto(produtoP);
  };

  const handleClose = (event?: React.SyntheticEvent | Event, reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpen(false);
  };

  return (
    <Stack spacing={2} width="100%">
      {results?.['cliente'] !== undefined && (
        <DadosDoCliente
          nome={results['cliente'].nome}
          telefone={results['cliente'].telefone}
          vendedor={vendedor.nome}
        />
      )}

      {results?.['categorias'] !== undefined && (
        <FiltroProduto categorias={results['categorias']} updateResult={updateResult} />
      )}

      {produtosListado.length !== 0 ? (
        <ProdutoView
          produtosListado={produtosListado}
          uf={results['partilha']}
          vendedor={vendedor}
          produtoSelecionado={produtoSelecionado}
        />
      ) : (
        <Box
          display="flex"
          flexDirection="column"
          gap="16px"
          justifyContent="center"
          alignItems="center"
          height="200px"
        >
          <Typography variant="h5" align="center">
            Nenhum produto disponível na categoria.
          </Typography>
        </Box>
      )}

      {produtosListado.length !== 0 && <BtnPlus add={addCarrinho} />}
      {produtoCar.length > 0 && <BtnFinalizar />}

      {produtoCar.map((o, index) => (
        <ProdutoCarrinhoView
          key={index}
          id={index}
          produto={o.produto}
          valor={o.valor}
          comissao={vendedor.comissao}
          quantidade={o.quantidade}
          removerProduto={removerProduto}
        />
      ))}
      <Snackbar
        open={open}
        autoHideDuration={6000}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <Alert onClose={handleClose} severity="error" variant="filled" sx={{ width: '100%' }}>
          {mensagemBar}
        </Alert>
      </Snackbar>
    </Stack>
  );
};

export default CalculoProdutoPreco;
